/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import clsx from 'clsx'
import {useDispatch, useSelector} from 'react-redux'
import moment from 'moment'
import {
  defaultMessages,
  MessageModel,
  UserInfoModel,
  defaultUserInfos,
  messageFromClient,
  toAbsoluteUrl,
} from '../../../../_metronic/helpers'
import MessageBoxV2 from '../../../Components/MessageBoxV2'
import {
  getRmsChat,
  getSingleChat,
  getSingleRmsChat,
  sendRmsSMSInbox,
  sendSMSInbox,
} from './InboxSlice/InboxSlice'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import Select from 'react-select'
import {getDedicatedNumber} from '../accounts/DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'
import {getBusinessName} from '../accounts/BusinessName/BusinessNameSlice/BusinessSlice'

type Props = {
  isDrawer?: boolean
  data: any
}

const bufferMessages = defaultMessages

const RmsInbox = ({isDrawer = false, data, rmsdata}: any) => {
  const [error, setError] = useState<any>({})
  const [options, setOptions] = useState({
    webLink: [
      {value: 'https/', label: 'link2'},
      {value: 'https', label: 'link3'},
    ],
    customLanding: [
      {value: 'https/', label: 'link2'},
      {value: 'https', label: 'link3'},
    ],
    optOut: [
      {value: "Reply 'STOP' to opt-out ", label: 'Reply Stop'},
      {value: 'STOP:{stoptxt.cc/}', label: 'custom survey'},
    ],
  })
  const dispatch = useDispatch()
  const [sendData, setSendData] = useState<any>({
    sender: '#SharedNum#',
    contacts: [],
    subject: '',
    media: '',
    message: '',
    optout: '',
    alphaId: '',
    gif: '',
    path: '',
    replyStopToOptOut: true,
  })
  const chat = useSelector(getSingleChat)

  const rmsSingleData = useSelector(getSingleRmsChat)
  const [chatUpdateFlag, toggleChatUpdateFlat] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [messages, setMessages] = useState<MessageModel[]>(bufferMessages)
  const [userInfos] = useState<UserInfoModel[]>(defaultUserInfos)

  const bussinessName = useSelector(getBusinessName)
  const virtualNumber = useSelector(getDedicatedNumber)

  let nu = chat?.items?.find((key: any) => key?.campaign_type == 'reply')?.sender

  const sendMessage = () => {
    const newMessage: MessageModel = {
      user: 2,
      type: 'out',
      text: message,
      time: 'Just now',
    }

    bufferMessages.push(newMessage)
    setMessages(bufferMessages)
    toggleChatUpdateFlat(!chatUpdateFlag)
    setMessage('')
    setTimeout(() => {
      bufferMessages.push(messageFromClient)
      setMessages(() => bufferMessages)
      toggleChatUpdateFlat((flag) => !flag)
    }, 1000)
  }

  const onEnterPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault()
      sendMessage()
    }
  }

  const handleSubmit = (e: any) => {
    let smsData = {
      sender: data?.sender?.value,
      message: sendData.message,
      contacts: [`${data}`],
      countryCode: '61',
    }
    dispatch(
      sendRmsSMSInbox({
        sender: sendData?.sender?.value,
        message: sendData.message,
        contacts: [`${nu}`],
        countryCode: '61',
      })
    )
    setSendData({
      ...sendData,
      contacts: [],
      subject: '',
      media: '',
      message: '',
      optout: '',
      alphaId: '',
      gif: '',
    })
  }

  useEffect(() => {}, [chat])

  return (
    <div
      className='card-body'
      id={isDrawer ? 'kt_drawer_chat_messenger_body' : 'kt_chat_messenger_body'}
    >
      <div
        className={clsx('scroll-y me-n5 pe-5', {'h-300px h-lg-auto': !isDrawer})}
        data-kt-element='messages'
        data-kt-scroll='true'
        data-kt-scroll-activate='{default: false, lg: true}'
        data-kt-scroll-max-height='auto'
        data-kt-scroll-dependencies={
          isDrawer
            ? '#kt_drawer_chat_messenger_header, #kt_drawer_chat_messenger_footer'
            : '#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer'
        }
        data-kt-scroll-wrappers={
          isDrawer ? '#kt_drawer_chat_messenger_body' : '#kt_content, #kt_chat_messenger_body'
        }
        data-kt-scroll-offset={isDrawer ? '0px' : '-2px'}
      >
        {data !== '' && (
          <>
            {rmsSingleData?.[0]?.rmsChat?.length > 0 &&
              [...rmsSingleData?.[0]?.rmsChat]?.map((message: any, index: any) => {
                // const userInfo = message?.adminDetails?._id !== SigninUser
                const userInfo = !(message?.type == 'sent')
                const templateAttr = {}

                return (
                  <>
                    {
                      <>
                        <div
                          key={`message${index}`}
                          className={clsx(
                            'd-flex',
                            'mb-10',
                            {'d-none': message.template},
                            {'flex-row-reverse': !userInfo}
                          )}
                          {...templateAttr}
                        >
                          <div
                            className={clsx(
                              'd-flex flex-column align-items',
                              `align-items-${userInfo ? 'start' : 'end'}`
                            )}
                          >
                            {userInfo ? (
                              <>
                                <div className='d-flex align-items-center mb-2'>
                                  <div className='symbol  symbol-35px symbol-circle '>
                                    {/* <img alt='Pic' src={toAbsoluteUrl(`/media/${userInfo.avatar}`)} /> */}
                                    <span className='circle1'>
                                      <img
                                        src={toAbsoluteUrl(
                                          '/media/logos/Logo-transparent_round.svg'
                                        )}
                                        alt='Profile Pic'
                                      />
                                    </span>
                                  </div>
                                  <div className='ms-3'>
                                    <a
                                      href='#'
                                      className='fs-5 fw-bolder text-gray-900 text-hover-primary me-2'
                                    >
                                      {message?.sender}
                                    </a>
                                    <span
                                      className='text-muted fs-7 mb-1'
                                      title={moment(message?.createdAt)?.format(
                                        'DD/MM/YYYY hh:mm A'
                                      )}
                                    >
                                      {moment(message?.createdAt)?.fromNow()}
                                    </span>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className='d-flex flex-row- align-items-center mb-2'>
                                  <div className='me-3'>
                                    <span className='text-muted fs-7 mb-1'></span>
                                    <span
                                      title={moment(message?.createdAt)?.format(
                                        'DD/MM/YYYY hh:mm A'
                                      )}
                                    >
                                      {moment(message?.createdAt)?.fromNow()}
                                    </span>
                                    <a
                                      href='#'
                                      className='fs-5 fw-bolder text-gray-900 text-hover-primary ms-2'
                                    >
                                      {message?.createdBy?.name !== undefined
                                        ? message?.createdBy?.name
                                        : 'Cellbot'}
                                    </a>
                                  </div>
                                  <div className='symbol  symbol-35px symbol-circle '>
                                    {/* <img alt='Pic' src={toAbsoluteUrl(`/media/${userInfo.avatar}`)} /> */}
                                    {message?.createdBy?.avatar !== undefined ? (
                                      <img src={message?.createdBy?.avatar} alt='Profile Pic' />
                                    ) : (
                                      <span className='circle1 cellbot'>
                                        <img
                                          src={toAbsoluteUrl('/media/logos/LogoSymbol.svg')}
                                          width={24}
                                          alt='Profile Pic'
                                        />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}

                            <div
                              className={clsx(
                                'p-5 rounded',
                                `bg-light-${userInfo ? 'info' : 'primary'}`,
                                'text-dark fw-bold mw-lg-400px',
                                `text-${userInfo ? 'start' : 'end'}`
                              )}
                              data-kt-element='message-text'
                              // dangerouslySetInnerHTML={{__html: message.text}}
                            >
                              {message?.rmsContent}
                            </div>
                          </div>
                        </div>
                      </>
                    }
                  </>
                )
              })}
          </>
        )}
      </div>

      {/* {AuthenticateUser('send-quick-sms') && (
        <>
          {data !== '' && (
            <>
              <div className='mb-7 mt-10 form-group '>
                <Select
                  onChange={(e: any) => {
                    setSendData({...sendData, sender: e})
                  }}
                  className='form-select bg-light-primary border-0 '
                  aria-label='Select example'
                  options={[
                    {
                      label: 'Dedicated Number',
                      options: virtualNumber?.map((key: any) => {
                        return {
                          value: key.audNumber,
                          label: `${key.audNumber}`,
                        }
                      }),
                    },
                    {
                      label: 'Bussiness Name',
                      options: bussinessName?.map((key: any) => {
                        return {
                          value: key.businessname,
                          label: `${key.businessname}`,
                        }
                      }),
                    },
                  ]}
                />
              </div>
            </>
          )}
          <MessageBoxV2
            setError={setError}
            disableTextfield={data == ''}
            setUserMessage={setSendData}
            userMessage={sendData}
            options={options}
            quickSms={true}
            showSelect={['landingpage', 'customfield', 'weblink']}
            isInbox={true}
          />

          <button onClick={handleSubmit} className='btn btn-primary'>
            Send SMS
          </button>
        </>
      )} */}
    </div>
  )
}

export default RmsInbox
